// extracted by mini-css-extract-plugin
module.exports = {"iconDetailContainer":"followup-main_iconDetailContainer__xCE6o","container":"followup-main_container__2fsdq"};